import React from 'react';
import ReactDOM from 'react-dom';
import { Form } from './Form';
import FocusTrap from 'focus-trap-react';
import FormUpdates1 from './FormUpdates1';
export const ModelUpdates = ({
  onClickOutside,
  onKeyDown,
  modalRef,
  buttonRef,
  closeModal,
  fundname,
  id,
  vocher_id,
  fundnamecompany,
  company,
  fundtype,
  fundtype1,
  fundtype2,
  fundtype3,
  fundtype4,
  fundtypeadmin,
  fundcompany,
  pricegeneral,
  priceprivate
}) => {


  return ReactDOM.createPortal(
    <FocusTrap>
      <aside
        tag="aside"
        role="dialog"
        tabIndex="-1"
        aria-modal="true"
        className="modal-cover"
        onClick={onClickOutside}
        onKeyDown={onKeyDown}
      >
        <div className="modal-area" ref={modalRef}>
          <button
            ref={buttonRef}
            aria-label="Close Modal"
            aria-labelledby="close-modal"
            className="_modal-close"
            onClick={closeModal}
          >
            <span id="close-modal" className="_hide-visual">
              Close
            </span>
            <svg className="_modal-close-icon" viewBox="0 0 40 40">
              <path d="M 10,10 L 30,30 M 30,10 L 10,30" />
            </svg>
          </button>
          <div className="modal-body">
            <FormUpdates1 
             reply={fundname}
             id={id}
             company={company}
            fundtype={fundtype} 
            fundnamecompany={fundnamecompany}
            fundtype1={fundtype1} 
            fundtype2={fundtype2} 
            fundtype3={fundtype3} 
            fundtype4={fundtype4} 
            vocher_id={vocher_id}
            fundtypeadmin1={fundtypeadmin} 
            fundcompany={fundcompany} 
            pricegeneral={pricegeneral} 
            priceprivate={priceprivate} 
            />
          </div>
        </div>
      </aside>
    </FocusTrap>,
    document.body
  );
};

export default ModelUpdates;
